import { FC, useEffect } from "react";
import { useUserSettings } from "../../../context/userSettingsContext";
import useToggle from "../../../hooks/useToggle";
import { useI18n } from "../../../hooks/useTranslations";
import Nav from "../Nav";
import AdministrationMenu from "./AdministrationMenu";
import MyAreaMenu from "./MyAreaMenu";

const Menu: FC = () => {
  const sidebar = useToggle();
  const i18n = useI18n();
  const userSettings = useUserSettings();

  useEffect(() => {
    // if it is the staging environment the document.titel is changed accordingly
    if (import.meta.env.MODE === "staging" && !document.title.includes(i18n.t.common.testEnvironment)) {
      document.title += " - " + i18n.t.common.testEnvironment;
    }
  }, []);

  return (
    <>
      <Nav>
        <Nav.List>
          <MyAreaMenu closeSidebar={sidebar.close} />
          <>{userSettings.canSeeAdministration && <AdministrationMenu closeSidebar={sidebar.close} />}</>
        </Nav.List>
      </Nav>
    </>
  );
};

export default Menu;
